import { addToEndOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import { ProductModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import { addToWishList } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { chain, AddToWishListParameter } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList"
import { getProductById, GetProductByIdApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";

interface Props {
    result: {
        wishList?: WishListModel;
        errorMessage?: string;
    };
}

type HandlerType = Handler<AddToWishListParameter, Props>;

export const SendTrackingCustom: HandlerType = async props => {
    const getproducIdParam: GetProductByIdApiV2Parameter={id: props.parameter.productInfos[0].productId};    
    let productModel : ProductModel;
    // eslint-disable-next-line prefer-const
    productModel = await getProductById(getproducIdParam); 
    addToWishList([productModel], '',props.parameter.productInfos[0], props.getState().context.session);
};

addToEndOfChain(chain, SendTrackingCustom);